module.exports = __webpack_public_path__ + "static/media/reactlogo.47507912.png";